// src/middleware/MaintenanceMiddleware.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMaintenanceMode } from '../hooks/useMaintenance';
import { message } from 'antd';

const ProtectedMainRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    
    const location = useLocation();
    const { isMaintenance, loading } = useMaintenanceMode();

    React.useEffect(() => {
        if (!loading && isMaintenance && location.pathname !== '/maintenance') {
            message.error(`We're currently performing maintenance to improve your experience. Please check back shortly. Thank you for your patience!`);
        }
    }, [isMaintenance, loading, location.pathname]);

    if (loading) {
        return null;
    }

    if (!isMaintenance && location.pathname === '/maintenance') {
        return <Navigate to="/" replace />;
    }

    if (isMaintenance && location.pathname !== '/maintenance') {
        return <Navigate to="/maintenance" replace />;
    }

    return <>{children}</>;
};

export default ProtectedMainRoute;